export enum AllowedProofOfDebtAlternativeType
{
    None,
    PreRequest,
    ProofOfDebt,
    LateProofOfDebt
}